import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id EBE654D8-89C1-4DAC-92E5-3534C55281F0
 * name view-gallery-outline
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-gallery-outline.svg
 * tags
 * - View 
 */
export const ViewGalleryOutlineIcon = createSvgIcon(<><path d="M1 3V21H23V3H1M21 5V14H3V5H21M11 16V19H8V16H11M3 16H6V19H3V16M13 19V16H16V19H13M18 19V16H21V19H18Z" /></>, 'ViewGalleryOutlineIcon');
export default ViewGalleryOutlineIcon